import React from 'react'

function VisaAssistanceSection() {

    const points = [
        "Expert Guidance for Every Country Visa",
        "End-to-End Assistance",
        "Hassle-Free Documentation Support",
        "High Approval Rates",
        "Experienced Team",
        "Fast & Reliable Processing"
    ];

    return (
        <section className="py-5  text-center">
            <div className="container">
                {/* <h2 className="mb-3">Visa Assistance Services</h2> */}
                
                <div className="row justify-content-center">
                <div className="col-12 col-md-9 col-lg-8">
                    <p className="mb-5 text-center">
                        Unlock the world with ease through our trusted visa services from Dubai. At Holiday Basket, we simplify your travel plans by providing quick, reliable visas assistance for countless destinations. Whether it’s for leisure, business, or family visits, we ensure a smooth and stress-free process so you can focus on making unforgettable memories. Your journey begins here!
                    </p>
                </div>
                </div>

                <div className="row">
                    {points.map((point, index) => (
                        <div key={index} className="col-md-4 mb-4">
                            <div className="p-4 border rounded h-100 shadow-sm">
                                <p className="mb-0 fw-medium">{point}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default VisaAssistanceSection